import module from '@kendu/grid/module'
import angular from 'angular'
import './style.scss'

export class KdGridComponent {
  constructor ($element, $scope, $timeout, $window) {
    this.$element = $element
    this.$scope = $scope
    this.$timeout = $timeout
    this.$window = $window
    this.resize = this.resize.bind(this)
  }

  $postLink () {
    angular.element(this.$window).on('resize', this.resize)
    this.$timeout(this.resize)
  }

  $onDestroy () {
    angular.element(this.$window).off('resize', this.resize)
  }

  resize () {
    const windowHeight = this.$window.innerHeight
    const elementHeight = this.getOffset(this.$element[0])

    this.$element.css('height', `${windowHeight - elementHeight}px`)
  }

  getOffset (element) {
    let y = 0

    while (element && !isNaN(element.offsetLeft) && !isNaN(element.offsetTop)) {
      y += element.offsetTop - element.scrollTop
      element = element.offsetParent
    }

    return y
  }
}

module.component('kdGrid', {
  controller: KdGridComponent,
})



// WEBPACK FOOTER //
// ./src/kendu/grid/components/kd-grid/component.js